var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A library for broadcasting messages over pubsub and managing 'lost messages'.
*/
// Global npm libraries
var _require = require('uuid'),
    uid = _require.v4; // Local libraries
// Constants


var TIME_BETWEEN_RETRIES = 5000; // time in milliseconds

var RETRY_LIMIT = 3;

var _this;

var Messaging = /*#__PURE__*/function () {
  "use strict";

  function Messaging() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Messaging);

    // Dependency Injection
    this.ipfs = localConfig.ipfs;

    if (!this.ipfs) {
      throw new Error('Instance of IPFS adapter required when instantiating Messaging Adapter.');
    }

    this.log = localConfig.log;

    if (!this.log) {
      throw new Error('A status log handler function required when instantitating Messaging Adapter');
    }

    this.encryption = localConfig.encryption;

    if (!this.encryption) {
      throw new Error('An instance of the encryption Adapter must be passed when instantiating the Messaging Adapter library.');
    } // 'embedded' node type used as default, will use embedded js-ipfs.
    // Alternative is 'external' which will use ipfs-http-client to control an
    // external IPFS node.


    this.nodeType = localConfig.nodeType;

    if (!this.nodeType) {
      // console.log('No node type specified. Assuming embedded js-ipfs.')
      this.nodeType = 'embedded';
    } // Encapsulate dependencies


    this.uid = uid; // State

    this.msgQueue = []; // Cache to store UUIDs of processed messages. Used to prevent duplicate
    // processing.

    this.msgCache = [];
    this.MSG_CACHE_SIZE = 30;
    _this = this;
  } // Send a message to a peer
  // The message is added to a queue that will automatically track ACK messages
  // and re-send the message if an ACK message is not received.


  _createClass(Messaging, [{
    key: "sendMsg",
    value: function () {
      var _sendMsg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(receiver, payload, thisNode) {
        var sender, inMsgObj, msgObj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // console.log(`sendMsg thisNode: `, thisNode)
                // Generate a message object
                sender = thisNode.ipfsId;
                inMsgObj = {
                  sender: sender,
                  receiver: receiver,
                  payload: payload
                };
                msgObj = this.generateMsgObj(inMsgObj); // const msgId = msgObj.uuid
                // Send message

                _context.next = 6;
                return this.publishToPubsubChannel(receiver, msgObj);

              case 6:
                // Add the message to the retry queue
                this.addMsgToQueue(msgObj);
                return _context.abrupt("return", true);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('Error in messaging.js/sendMsg()');
                throw _context.t0;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function sendMsg(_x, _x2, _x3) {
        return _sendMsg.apply(this, arguments);
      }

      return sendMsg;
    }() // Publish an ACK (acknowldge) message. Does not wait for any reply. Just fires
    // and returns.

  }, {
    key: "sendAck",
    value: function () {
      var _sendAck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, thisNode) {
        var ackMsgObj;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.generateAckMsg(data, thisNode);

              case 3:
                ackMsgObj = _context2.sent;
                _context2.next = 6;
                return this.publishToPubsubChannel(data.sender, ackMsgObj);

              case 6:
                return _context2.abrupt("return", true);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in sendAck()');
                throw _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function sendAck(_x4, _x5) {
        return _sendAck.apply(this, arguments);
      }

      return sendAck;
    }() // A handler function that is called when a new message is recieved on the
    // pubsub channel for this IPFS node. It does the following:
    // - Decrypts the message.
    // - Sends an ACK message to the sender of the message.
    // - Returns an object containing the message and metadata.

  }, {
    key: "handleIncomingData",
    value: function () {
      var _handleIncomingData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(msg, thisNode) {
        var thisNodeId, from, channel, data, decryptedPayload, obj, alreadyProcessed, retObj;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                // console.log('handleIncomingData() msg: ', msg)
                // console.log('thisNode: ', thisNode)
                thisNodeId = thisNode.ipfsId; // Get data about the message.

                from = msg.from;
                channel = msg.topicIDs[0]; // Ignore this message if it originated from this IPFS node.

                if (!(from === thisNodeId)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                // The data on browsers comes through as a uint8array, and on node.js
                // implementiong it comes through as a string when using js-ipfs. But when
                // using ipfs-http-client with an external go-ipfs node, it comes thorugh
                // as a uint8Array too. Browsers need to
                // convert the message from a uint8array to a string.
                if (thisNode.type === 'browser' || this.nodeType === 'external') {
                  // console.log('Node type is browser')
                  msg.data = new TextDecoder('utf-8').decode(msg.data);
                } // console.log('msg.data: ', msg.data)
                // Parse the data into a JSON object. It starts as a Buffer that needs
                // to be converted to a string, then parsed to a JSON object.
                // For some reason I have to JSON parse it twice. Not sure why.


                data = JSON.parse(msg.data.toString()); // console.log('message data: ', data)
                // Decrypt the payload

                _context3.next = 10;
                return this.encryption.decryptMsg(data.payload);

              case 10:
                decryptedPayload = _context3.sent;

                if (!decryptedPayload.includes('"apiName":"ACK"')) {
                  _context3.next = 17;
                  break;
                }

                this.log.statusLog(2, "ACK message received for ".concat(data.uuid));
                this.delMsgFromQueue(data);
                return _context3.abrupt("return", false);

              case 17:
                this.log.statusLog(2, "Private pubsub message recieved from ".concat(from, " on channel ").concat(channel, " with message ID ").concat(data.uuid));

              case 18:
                // Debug logs
                if (decryptedPayload.includes('"id"')) {
                  obj = JSON.parse(decryptedPayload);

                  if (obj.result) {
                    this.log.statusLog(2, "Message ID ".concat(data.uuid, " contains RPC response with ID ").concat(obj.id));
                  } else {
                    this.log.statusLog(2, "Message ID ".concat(data.uuid, " contains RPC request with ID ").concat(obj.id));
                  }
                } // Send an ACK message


                _context3.next = 21;
                return this.sendAck(data, thisNode);

              case 21:
                // Ignore message if its already been processed.
                alreadyProcessed = this._checkIfAlreadyProcessed(data.uuid);

                if (!alreadyProcessed) {
                  _context3.next = 25;
                  break;
                }

                console.log("Message ".concat(data.uuid, " already processed"));
                return _context3.abrupt("return", false);

              case 25:
                // Replace the encrypted data with the decrypted data.
                data.payload = decryptedPayload;
                retObj = {
                  from: from,
                  channel: channel,
                  data: data
                }; // console.log(
                //   `new pubsub message received: ${JSON.stringify(retObj, null, 2)}`
                // )

                return _context3.abrupt("return", retObj);

              case 30:
                _context3.prev = 30;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in handleIncomingData(): ', _context3.t0); // throw err
                // Do not throw an error. This is a top-level function called by an Interval.

                return _context3.abrupt("return", false);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 30]]);
      }));

      function handleIncomingData(_x6, _x7) {
        return _handleIncomingData.apply(this, arguments);
      }

      return handleIncomingData;
    }() // Generate a message object with UUID and timestamp.

  }, {
    key: "generateMsgObj",
    value: function generateMsgObj() {
      var inMsgObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var sender = inMsgObj.sender,
            receiver = inMsgObj.receiver,
            payload = inMsgObj.payload; // Input validation

        if (!sender) {
          throw new Error('Sender required when calling generateMsgObj()');
        }

        if (!receiver) {
          throw new Error('Receiver required when calling generateMsgObj()');
        }

        if (!payload) {
          throw new Error('Payload required when calling generateMsgObj()');
        }

        var uuid = this.uid();
        var now = new Date();
        var timestamp = now.toISOString();
        var outMsgObj = {
          timestamp: timestamp,
          uuid: uuid,
          sender: sender,
          receiver: receiver,
          payload: payload
        };
        return outMsgObj;
      } catch (err) {
        console.log('Error in generateMsgObj()');
        throw err;
      }
    } // Generate an ACK (acknowledge) message.

  }, {
    key: "generateAckMsg",
    value: function () {
      var _generateAckMsg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data, thisNode) {
        var receiver, uuid, ackMsg, peerData, payload, sender, inMsgObj, outMsgObj;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                // console.log('thisNode: ', thisNode)
                // The sender of the original messages is the receiver of the ACK message.
                receiver = data.sender;
                uuid = data.uuid;
                ackMsg = {
                  apiName: 'ACK'
                };
                peerData = thisNode.peerData.filter(function (x) {
                  return x.from === receiver;
                }); // Encrypt the string with the peers public key.

                _context4.next = 7;
                return this.encryption.encryptMsg(peerData[0], JSON.stringify(ackMsg));

              case 7:
                payload = _context4.sent;
                sender = thisNode.ipfsId;
                inMsgObj = {
                  sender: sender,
                  receiver: receiver,
                  payload: payload
                };
                outMsgObj = this.generateMsgObj(inMsgObj); // Replace the message UUID with the UUID from the original message.

                outMsgObj.uuid = uuid;
                this.log.statusLog(2, "Sending ACK message for ID ".concat(uuid));
                return _context4.abrupt("return", outMsgObj);

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](0);
                console.error('Error in generateAckMsg()');
                throw _context4.t0;

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 16]]);
      }));

      function generateAckMsg(_x8, _x9) {
        return _generateAckMsg.apply(this, arguments);
      }

      return generateAckMsg;
    }() // Converts an input string to a Buffer and then broadcasts it to the given
    // pubsub room.

  }, {
    key: "publishToPubsubChannel",
    value: function () {
      var _publishToPubsubChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(chanName, msgObj) {
        var msgBuf;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                msgBuf = Buffer.from(JSON.stringify(msgObj)); // Publish the message to the pubsub channel.

                _context5.next = 4;
                return this.ipfs.ipfs.pubsub.publish(chanName, msgBuf);

              case 4:
                // console.log('msgObj: ', msgObj)
                // Used for debugging.
                if (msgObj.uuid) {
                  this.log.statusLog(2, "New message published to private channel ".concat(chanName, " with ID ").concat(msgObj.uuid));
                } else {
                  this.log.statusLog(2, "New announcement message published to broadcast channel ".concat(chanName));
                }

                return _context5.abrupt("return", true);

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                console.error('Error in publishToPubsubChannel()');
                throw _context5.t0;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function publishToPubsubChannel(_x10, _x11) {
        return _publishToPubsubChannel.apply(this, arguments);
      }

      return publishToPubsubChannel;
    }() // Checks the UUID to see if the message has already been processed. Returns
    // true if the UUID exists in the list of processed messages.

  }, {
    key: "_checkIfAlreadyProcessed",
    value: function _checkIfAlreadyProcessed(uuid) {
      // Check if the hash is in the array of already processed message.
      var alreadyProcessed = this.msgCache.includes(uuid); // Update the msgCache if this is a new message.

      if (!alreadyProcessed) {
        // Add the uuid to the array.
        this.msgCache.push(uuid); // If the array is at its max size, then remove the oldest element.

        if (this.msgCache.length > this.MSG_CACHE_SIZE) {
          this.msgCache.shift();
        }
      }

      return alreadyProcessed;
    } // Stops the Interval Timer and deletes a message from the queue when an
    // ACK message is received.

  }, {
    key: "delMsgFromQueue",
    value: function delMsgFromQueue(msgObj) {
      // Loop through the message queue
      for (var i = 0; i < this.msgQueue.length; i++) {
        var thisMsg = this.msgQueue[i]; // Find the matching entry.

        if (msgObj.uuid === thisMsg.uuid) {
          // console.log(`thisMsg: `, thisMsg)
          // Stop the Interval
          try {
            clearInterval(thisMsg.intervalHandle); // console.log('Interval stopped')
          } catch (err) {
            /* exit quietly */
          } // Delete the entry from the msgQueue array.


          this.msgQueue.splice(i, 1);
          break;
        }
      }

      return true;
    } // Adds a message object to the message queue. Starts an interval timer that
    // will repeat the message periodically until an ACK message is received.

  }, {
    key: "addMsgToQueue",
    value: function addMsgToQueue(msgObj) {
      try {
        msgObj.retryCnt = 1; // Start interval for repeating message

        var intervalHandle = setInterval(function () {
          _this.resendMsg(msgObj);
        }, TIME_BETWEEN_RETRIES); // Add interval handle to message object.

        msgObj.intervalHandle = intervalHandle; // Add message object to the queue.

        this.msgQueue.push(msgObj);
        return msgObj;
      } catch (err) {
        console.error('Error in addMsgToQueue');
        throw err;
      }
    } // Called by an Interval Timer. This function re-publishes a message to a
    // pubsub channel.

  }, {
    key: "resendMsg",
    value: function () {
      var _resendMsg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(msgObj) {
        var retryCnt, intervalHandle, receiver;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                // console.log(`resendMsg() msgObj: ${JSON.stringify(msgObj, null, 2)}`)
                retryCnt = msgObj.retryCnt, intervalHandle = msgObj.intervalHandle, receiver = msgObj.receiver; // console.log('resendMsg() retryCnt: ', retryCnt)

                if (!(retryCnt < RETRY_LIMIT)) {
                  _context6.next = 9;
                  break;
                }

                // Increment the retry
                msgObj.retryCnt++; // Send message

                _context6.next = 6;
                return _this.publishToPubsubChannel(receiver, msgObj);

              case 6:
                return _context6.abrupt("return", 1);

              case 9:
                // Retry count exceeded.
                // Disable the interval handler
                clearInterval(intervalHandle);
                return _context6.abrupt("return", 2);

              case 11:
                _context6.next = 17;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);
                console.error('Error in resendMsg(): ', _context6.t0); // Do not throw an error. This is a top-level function called by an Interval.

                return _context6.abrupt("return", 0);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 13]]);
      }));

      function resendMsg(_x12) {
        return _resendMsg.apply(this, arguments);
      }

      return resendMsg;
    }()
  }]);

  return Messaging;
}();

module.exports = Messaging;